import * as React from 'react';

/* APP, CONTEXTOS */

import { useAppContextoReact } from '../../servicos/app/AppContextoReact';

/* ENUMERAÇÕES */

/* COMPONENTES */

import Typography from '@mui/material/Typography';
import {Box, Grid} from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha';

interface IResetPassword
{
    setNewPassword: (newPassword:boolean) => void
}

const ResetPassword = (props:IResetPassword) =>
{
    const userContext = useAppContextoReact();

    const [email, setEmail] = React.useState<string>('');
    const [error, setError] = React.useState<boolean>(false);
    const [success, setSuccess] = React.useState<boolean>(false);
    const [message, setMessage] = React.useState<string>('');
    const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);

    const handleError = React.useCallback((errorMsg?:string) => 
	{
		bananinhaDelegate?.abrir(errorMsg ? errorMsg : 'E-mail não encontrado.', "error");
	}, [bananinhaDelegate]);

    const handleSuccess = React.useCallback((successMsg?:string) => 
	{
		bananinhaDelegate?.abrir(successMsg ? successMsg : 'Enviamos um email com instruções para redefinir sua senha.', "success");
	}, [bananinhaDelegate])

    const handleEmailChange = (event:any) => {
        setEmail(event.target.value);
    };
    
    const handleResetPassword = async () =>
    {
        try
        {
            const res:any  = await userContext?.usuario.resetPassword(email);

            if (res.code && res.code === "auth/user-not-found")
                handleError();
            else
                handleSuccess();
        }
        catch(e)
        {
            handleError()
        }
    }

    return <>
        <Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
        <Grid container justifyContent={'center'}>
            <Typography component="h1" variant="pbs" sx={{mt:5}}>Resetar senha</Typography>
            <Box component="div" sx={{ mt: 1, width: '100%' }}>
                <TextField margin="normal" required fullWidth id="email" label="E-mail do usuário" name="email" autoComplete="email" autoFocus onChange={handleEmailChange} error={error} />
                {
                    error &&
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} textAlign={'center'} sx={{width: '100%', py:3, px:5, mt:3, borderRadius: 3}}>
                            <Typography component="p" variant="pxs" sx={{color: "#fff"}}>{message}</Typography>
                        </Box>
                }
                {
                    success &&
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} textAlign={'center'} sx={{width: '100%', py:3, px:5, mt:3, borderRadius: 3}}>
                            <Typography component="p" variant="pxs" sx={{color: "#fff"}}>{message}</Typography>
                        </Box>
                }	
                <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, height: 50 }} onClick={handleResetPassword}>
                    Enviar
                </Button>            
            </Box>
            <Grid item xs justifyContent={'flex-start'} textAlign={'center'}>
                <Link href="#" variant="body2" onClick={() => {props.setNewPassword(false)}}>
                    Retornar ao login
                </Link>
            </Grid>
        </Grid>
    </>
}

export default ResetPassword; 